module.exports = __webpack_public_path__ + "assets/img/grandPrize.40a0a91b.gif";